
/** HELPERS */
export function getShortDateDisplay(date) {
  const options = { weekday: 'short', month: 'short', day: 'numeric' };
  return date.toLocaleDateString('en-US', options); // e.g. "Sun, Jun 14"
}

export function getDateValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}




// CREATE One Cheat Meal
export async function createOneCheatMeal(uId, token, cm) {
  // return true if create is successful, else throws error.
  // return response.json() if create is successful, else throws error.

  console.log('*** starting createOneCheatMeal(cm) ***', cm);
  // build the REST API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals.json?auth=${token}`, {
    method: 'POST',
    body: JSON.stringify(cm)
  });
  // response
  const responseData = await response.json();
  if (!response.ok) {
    throw new Error(response.message || 'Failed to add a new Cheat Meal');
  } else {
    // return true;
    return responseData;
  }


}


// READ ALL Cheat Meals
export async function readAllCheatMeals(uId, token) {
  // this function returns an object, or null

  console.log('*** starting readAllCheatMeals() ***');

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals.json?auth=${token}`);

  // error handling
  if (!response.ok) {
    throw new Error(response.message || "Failed to get all Cheat Meals");
  }

  // return the data
  return response.json();
}


// READ ONE Cheat Meal
export async function getOneCheatMeal(uId, token, cheatMealId) {
  console.log('**** starting getOneCheatMeal(uId, token, cheatMealId) ******', uId, token, cheatMealId);

  // API Call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals/${cheatMealId}.json?auth=${token}`);
  const responseData = await response.json();

  // err handling
  if (!response.ok) {
    console.log('*** err ***', response);
    throw new Error(response.message || 'Failed to get one Cheat Meal' + cheatMealId);
  }

  let cm = null;
  if (responseData) {
    cm = responseData;
  }
  return cm;
}


// UPDATE One Cheat Meal
export async function updateOneCheatMeal(uId, token, cmId, cm) {
  // return true if update is successful, or error.

  console.log('*** starting updateOneCheatMeal(cm) ***', cmId, cm);

  // api call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals/${cmId}.json?auth=${token}`, {
    method: 'PATCH',
    body: JSON.stringify(cm)
  });

  // response
  if (!response.ok) {
    throw new Error(response.message || 'Failed to update a Cheat Meal');
  } else {
    return response.json();
  }

}


// DELETE One Cheat Meal
export async function deleteOneCheatMeal(uId, token, cmId) {
  // return true if delete is successful, or error.

  console.log('*** starting deleteOneCheatMeal(cmId) ***', cmId);

  // API call
  const response = await fetch(`https://stackin-vue-default-rtdb.firebaseio.com/users/${uId}/cheatmeals/${cmId}.json?auth=${token}`, {
    method: 'DELETE',
  });

  // response
  const responseData = await response.json();
  if (!response.ok) {
    throw new Error(response.message || 'Failed to delete a Cheat Meal');
  } else {
    return responseData;
  }
}

